export default __webpack_public_path__ + "static/article-renovation-best-indoor-plants-93fee1db03ac057a086494ff94bd3fdf.jpg";